export const version = '1.1.2';
export const navbarBreakPoint = 'xl'; // Vertical navbar breakpoint
export const topNavbarBreakpoint = 'lg';
export const themeVariants = ['light', 'dark', 'auto'];

export const settings = {
  isFluid: true,
  isRTL: false,
  isDark: false,
  theme: 'light',
  navbarPosition: 'vertical',
  showBurgerMenu: false, // controls showing vertical nav on mobile
  currency: '$',
  isNavbarVerticalCollapsed: false, // toggle vertical navbar collapse
  navbarStyle: process.env.REACT_APP_NAVBAR_STYLE || 'vibrant'
};

export const VIDEO_EMBED_URL =
  process.env.REACT_APP_ONBOARDING_VIDEO_URL ||
  'https://www.youtube.com/embed/U-azNSIQ8Is';

export default { version, navbarBreakPoint, topNavbarBreakpoint, settings, VIDEO_EMBED_URL };
